'use strict';

const createStore = require('redux').createStore;

const reducer = function (state, action) {
    if (state === undefined) {
        return {
            comments: {},
            home: {},
        };
    }

    const newState = Object.assign({}, state);
    switch (action.type) {
    case 'comment':
        newState.comments[action.data.id] = action.data;
        break;
    case 'home':
        newState.home = action.data;
        break;
    }

    return newState;
};

module.exports = {
    factory(initialState) {
        return createStore(reducer, initialState);
    },
};



/** WEBPACK FOOTER **
 ** ./common/redux-store.js
 **/